var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0076 13.7225C15.0076 15.4685 13.5916 16.8835 11.8456 16.8835C10.0996 16.8835 8.68457 15.4685 8.68457 13.7225C8.68457 11.9755 10.0996 10.5605 11.8456 10.5605C13.5916 10.5605 15.0076 11.9755 15.0076 13.7225Z",
    stroke: "#9A9AA7",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0967 13.7218C19.1357 9.59368 15.6527 7.11719 11.8447 7.11719H11.8487C8.04068 7.11719 4.55768 9.59368 2.59668 13.7218",
    stroke: "#9A9AA7",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfEyeIcon);
export default __webpack_public_path__ + "static/media/halfEyeIcon.548effcbe9f4003f8b0637132cec0842.svg";
export { ForwardRef as ReactComponent };